import { render, staticRenderFns } from "./item-reply.vue?vue&type=template&id=21854b72"
import script from "./item-reply.vue?vue&type=script&lang=js"
export * from "./item-reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports